const Pinterest = {
  load() {
    delete window["PIN_" + ~~(new Date().getTime() / 864e5)];
    $.getScript("//assets.pinterest.com/js/pinit.js");
  },
};

$(document).on("turbo:load", () => Pinterest.load());
